import React from 'react';

class Welcome extends React.PureComponent {
  render() {
    return (
      <section className="heading-section">
        <h1>Welcome to our page!</h1>
        <p>
          In pariatur elit ipsum sit do velit incididunt ad laborum tempor
          pariatur esse non. Sit excepteur tempor ipsum nisi elit occaecat sunt
          proident deserunt ut ullamco. Et pariatur est ipsum ea dolore ullamco
          consectetur veniam do dolor enim. Commodo tempor ex ipsum laboris ea
          exercitation cupidatat elit. Labore magna consectetur et voluptate
          consectetur minim velit mollit.
        </p>
        <p>
          Adipisicing commodo dolor non ipsum eiusmod eiusmod. Lorem amet nisi
          officia magna mollit eiusmod id adipisicing laboris consequat enim.
          Tempor irure sunt tempor do enim adipisicing non fugiat duis laborum
          id mollit. Commodo aliquip duis sit occaecat culpa culpa ea ex officia
          ullamco consequat. Enim officia esse ad commodo occaecat pariatur ex
          laboris commodo incididunt sit enim do proident. Reprehenderit ad
          labore velit cillum do deserunt incididunt ipsum labore laboris in
          consectetur Lorem. Commodo qui ullamco aliquip minim sunt veniam.
        </p>
      </section>
    );
  }
}

export default Welcome;
